/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Alert } from 'sarsaparilla';

import {
    AdditionalChallengeRequiredAlert,
    RecaptchaFailedAlert,
} from '../../../recaptcha';

export type RequestPasswordResetErrorType =
    'recaptchaFailed' | 'additionalChallenge' | 'unknown' | null;

interface RequestPasswordResetErrorsProps {
    errorType: RequestPasswordResetErrorType;
    className?: string;
}

export function RequestPasswordResetErrors({
    errorType,
    className,
}: RequestPasswordResetErrorsProps) {
    if (!errorType) {
        return null;
    }

    if (errorType === 'additionalChallenge') {
        return <AdditionalChallengeRequiredAlert className={className} />;
    }

    if (errorType === 'recaptchaFailed') {
        return <RecaptchaFailedAlert className={className} />;
    }

    return (
        <Alert
            type="error"
            heading="Error Sending Reset Request"
            shouldFocusOnMount
            className={className}
        >
            Something went wrong while attempting to send a reset request. Please try
            again in a moment. If the problem persists, try refreshing the page.
        </Alert>
    );
}
